module.exports = __webpack_public_path__ + "img/rly.0b1ef9a4.svg";